import axios from 'axios';
import { LTI_1P3_DEEP_LINK_RETURN } from '../../constants/endpoints';

export type DeepLinkReturnPayload = {
  contentItems: Array<{
    type?: string;
    url?: string;
    title?: string;
    text?: string;
    custom?: Record<string, string>;
    lineItem?: {
      scoreMaximum?: number;
      label?: string;
      resourceId?: string;
      tag?: string;
    };
  }>;
  clientId: string;
  providerId: string;
  spaceId?: string;
  resourceLinkId?: string;
};

const fetchDeepLinkReturn = async (
  token: string
): Promise<DeepLinkReturnPayload> => {
  const { data } = await axios.get(LTI_1P3_DEEP_LINK_RETURN(token), {
    withCredentials: true,
  });
  return data?.result ?? data;
};

export default fetchDeepLinkReturn;
